var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTumbler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.48 124.48",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tumbler_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:18px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tumbler_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tumbler_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tumbler_svg__cls-1",
    d: "M105.15 3l5.33 88.32a30.16 30.16 0 01-30.17 30.16H33.16A30.16 30.16 0 013 91.32L8.32 3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tumbler_svg__cls-1",
    d: "M98.63 65.58L100 86.67a24.26 24.26 0 01-24.3 24.26H37.78a24.26 24.26 0 01-24.26-24.26l1.32-21.09"
  })))));
}

var MemoSvgTumbler = /*#__PURE__*/React.memo(SvgTumbler);
export default MemoSvgTumbler;